const ElementDataForm = () => {
  return (
    <form className="animate-in fade-in-20 duration-1000">Formulário</form>
  );
};

export default ElementDataForm;
